import abiPFP from './abiPFP.json';
import abiICO from './abiICO.json';
export const pfpContractAddress = '0xA453F89d58485B2F00064c7322fB826fAc0962D1';
// export const bnbContractAddress = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c';
export const wbtcContractAddress = '0xeb2c88AE22dBc1a944adc555F272d1C435F62E3B';
export const usdtContractAddress = '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd';
export const icoContractAddress = '0x5709412795889110DFcB3Ab0c459cF5379411274';


export const pfpAbi = abiPFP;
export const icoAbi = abiICO;
